<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">People</h3>

      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->
  <div #peopleContainer class="card-body" style="">


    <div style="margin: 18px 15px 0px; box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15); border-radius: 4px;">
      <div class="input-group mb-5">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
        </div>
        <input type="text" class="form-control" placeholder="Search by name or email" [(ngModel)]="filter" (ngModelChange)="onFilterChanged($event)" aria-label="Username" aria-describedby="basic-addon1" />
      </div>
    </div>

    <div class="participant-list" style="">
      <div>
        <page-load-header *ngIf="searching"></page-load-header>
        <ul *ngIf="!searching">
          <ng-container *ngFor="let activeUser of activeUsers.users">
            <li *ngIf="activeUser.connected">
              <div class="d-flex align-items-center pb-3">
                <div class="mr-auto">
                  <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + activeUser.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ activeUser.id }}-avatar.png"   />
                  <span class="participant-name ml-2">{{ activeUser.firstName }} {{ activeUser.lastName }} </span>
                </div>

                <span *ngIf="user.id == activeUser.id" class="participant-menu">
                  <strong>This is you</strong>
                </span>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="people-pages">
      <div class="left"><a *ngIf="currentPage > 0" type="button" class="text-primary cursor-pointer" (click)="goToPrevPage()">Prev</a></div>
      <div class="info">Page {{ currentPage + 1 }} of {{ activeUsers.totalPages + 1 }} ({{ activeUsers.count }} total)</div>
      <div class="right"><a *ngIf="currentPage < activeUsers.totalPages" type="button" class="text-primary cursor-pointer" (click)="goToNextPage()">Next</a></div>

      <!-- <a *ngFor="let page of pageCount; let i = index" type="button" class="text-primary cursor-pointer mr-1" (click)="goToPage(i)">{{ i + 1 }}</a> -->
    </div>
  </div>
  <!-- End Body -->

  <!-- End Footer -->
</div>
